<template>
    <div>
        <base-header class="pb-6">
            <div class="row align-items-center py-4">
                <div class="col-lg-6 col-7">
                    <h6 class="h2 text-white d-inline-block mb-0">{{ $t('invoicesPage.invoices') }}</h6>
                </div>
            </div>
        </base-header>

        <div class="container-fluid mt--6">
            <div class="row">
                <div class="col">
                    <card>
                        <el-tabs
                            v-model="selectedHotelId"
                            :class="{'hide-tab-pane': hotels.length === 1}"
                            @tab-click="hotelChanged">
                            <el-tab-pane
                                v-for="hotel in hotels"
                                :key="hotel.id"
                                :label="hotel.name"
                                :name="hotel.id.toString()">
                                <el-table
                                    class="table-responsive table-flush"
                                    border
                                    header-row-class-name="thead-light"
                                    :data="filteredData"
                                    :empty-text="isLoadingHotels
                                    ? $t('general.loading') + '...'
                                    : $t('invoicesPage.noInvoice')"
                                    lazy>

                                    <el-table-column :label="$t('general.invoiceNo')" prop="invoice_no" sortable/>
                                    <el-table-column :label="$t('general.dateOfIssue')" prop="date" sortable/>
                                    <el-table-column :label="$t('general.dueDate')" prop="due_date" sortable/>

                                    <el-table-column :label="$t('general.price')" sortable v-slot="{row: invoice}">
                                        {{ invoice.total }} {{ invoice.currency }}
                                    </el-table-column>

                                    <el-table-column :label="$t('general.status')" sortable v-slot="{row: invoice}">
                                        <span v-if="!invoice.is_cancel_invoice">
                                            {{ invoiceStatuses[invoice.status] }}
                                        </span>
                                    </el-table-column>

                                    <el-table-column
                                        :label="$t('general.actions')"
                                        class-name="actions-column"
                                        width="120px"
                                        v-slot="{row: invoice}">
                                        <el-tooltip
                                            class="item"
                                            effect="dark"
                                            :content="$t('invoicesPage.downloadInvoice')"
                                            placement="top">
                                            <button type="button" @click="downloadInvoice(invoice)">
                                                <i class="ai ai-download text-default"></i>
                                            </button>
                                        </el-tooltip>
                                    </el-table-column>

                                </el-table>

                                <el-pagination
                                    background
                                    layout="prev, pager, next"
                                    class="permission-pagination"
                                    :total="itemsCount"
                                    :page-size="itemsPerPage"
                                    @current-change="currentPage = $event">
                                </el-pagination>
                            </el-tab-pane>
                        </el-tabs>
                    </card>
                </div>
            </div>
        </div>
    </div>
</template>
<script>
    import downloadInvoiceMixin from '@/mixins/download-invoice'
    import {BaseProgress} from '@/components';
    import {
        Dialog,
        Dropdown,
        DropdownItem,
        DropdownMenu,
        Form,
        FormItem,
        Option,
        Pagination,
        Select,
        Table,
        TableColumn,
        TabPane,
        Tabs,
        Tooltip,
    } from 'element-ui'

    export default {
        name: 'user-list',
        mixins: [downloadInvoiceMixin],
        components: {
            BaseProgress,
            [Dialog.name]: Dialog,
            [Table.name]: Table,
            [TableColumn.name]: TableColumn,
            [Dropdown.name]: Dropdown,
            [DropdownItem.name]: DropdownItem,
            [DropdownMenu.name]: DropdownMenu,
            [Form.name]: Form,
            [FormItem.name]: FormItem,
            [Select.name]: Select,
            [Option.name]: Option,
            [Pagination.name]: Pagination,
            [Tabs.name]: Tabs,
            [TabPane.name]: TabPane,
            [Tooltip.name]: Tooltip,
        },
        computed: {
            filteredData: {
                get() {
                    let data = JSON.parse(JSON.stringify(this.invoices));

                    // this.pageCount = Math.ceil(data.length / this.itemsPerPage) || 1;

                    this.itemsCount = data.length;

                    /* Pagination START */
                    const from = (this.currentPage - 1) * this.itemsPerPage;
                    const to = from + this.itemsPerPage;
                    data = data.slice(from, to);
                    /* Pagination END */

                    return data;
                }
            },
        },
        data() {
            return {
                hotels: [],
                selectedHotel: {},
                selectedHotelId: null,
                invoices: [],
                currentPage: 1,
                itemsPerPage: 10,
                itemsCount: 0,
                isLoadingHotels: true,
                filter: {
                    hotels: null,
                    applications: null
                },
                invoiceStatuses: {
                    1: this.$t('invoicesPage.paid'),
                    2: this.$t('invoicesPage.unpaid'),
                    4: this.$t('invoicesPage.cancelled'),
                },
            }
        },
        methods: {
            hotelChanged(tab) {
                const selectedHotel = this.hotels.find(hotel => hotel.id === parseInt(tab.name));
                this.invoices = selectedHotel.invoices;
            },
        },
        async created() {
            this.isLoadingHotels = true;
            this.hotels = (await this.$axios.get('/api/hotels?include=invoices')).data.data.map(hotel => {
                hotel.invoices = hotel.invoices.map(invoice => {
                    if (invoice.currency === 'HUF') {
                        invoice.total = parseInt(invoice.total);
                    }

                    return invoice;
                });

                return hotel;
            });
            this.isLoadingHotels = false;

            this.selectedHotel = this.hotels[0];
            this.invoices = this.selectedHotel.invoices;
            this.selectedHotelId = this.selectedHotel ? this.selectedHotel.id.toString() : null;
        }
    }
</script>
<style lang="scss">
    .filter-container {
        display: inline-flex;
        margin-right: .5rem;
    }

    .permission-editor-modal {
        .el-dialog__body {
            padding: 0;
        }
    }

    .permission-pagination {
        display: table;
        margin-left: auto;
        margin-right: auto;
        margin-top: 1rem;
    }

    .flex-right {
        display: flex;
        justify-content: flex-end;
    }
</style>
